/**
 * Created by moran on 7/27/17.
 */
export const SUPER_HERO = 'SUPER_HERO';
export const HERO = 'HERO';
